const loadedScripts = []

export default class AsyncScriptsLoader {

  /**
   * @param {string[]} scripts
   */
  constructor(scripts) {
    this._loaded = false
    this._onload = []
    this.scripts = scripts
  }

  isReady() { return this._loaded }

  _onScriptLoad() {
    this._loaded = true
    this._onload = this._onload.filter(fun => {
      fun()
      return false
    })
  }

  _loadScripts(urls) {
    if (!urls.length) {
      this._onScriptLoad()
    } else {
      const url = urls[0]
      if (!loadedScripts.find(u => u === url)) {
        let script = document.createElement('script')
        script.src = url
        script.setAttribute('async', 'true')
        script.setAttribute('defer', 'true')
        document.head.appendChild(script)
        script.onload = () => {
          loadedScripts.push(url)
          this._loadScripts(urls.slice(1))
        }
      } else {
        this._onScriptLoad()
      }
    }
  }

  load() {
    if (this.isReady()) return

    this._loadScripts(this.scripts)

    return this
  }

  onLoad(callback) {
    if (this.isReady()) callback()
    else {
      this._onload.push(callback)
    }
    return this
  }
}
